export const manifest = {
  screens: {
    scr_it2rw5: { name: "Home", route: "/" },
  },
}
